import React from "react";

const AvatarStack = ({ users = [], maxVisible = 4 }) => {
  const visibleUsers = users.slice(0, maxVisible);
  const remainingCount = users.length - maxVisible;

  return (
    <div className="flex -space-x-4 rtl:space-x-reverse">
      {visibleUsers?.map((user, index) =>
        user?.profileImageUrl ? (
          <div
            className="md:w-10 md:h-10 w-5 rounded-full ring-2"
            style={{
              backgroundImage: `url("${user?.profileImageUrl}")`,
              backgroundSize: "cover",
            }}
          ></div>
        ) : (
          <div className="md:w-10 md:h-10 w-5 flex justify-center items-center font-semibold text-white rounded-full bg-highlight ring-2">
{user?.name && user.name.charAt(0).toUpperCase()}
          </div>
        )
      )}

      {remainingCount > 0 && (
        <div className="flex items-center justify-center w-10 h-10 text-xs font-medium text-white bg-dark-strong border-2 border-buffer rounded-full">
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

export default AvatarStack;
